let newBaseApi = `https://api.bl.quizard.live`;

export const apiUrl = {
    activityLog:`${newBaseApi}/api/v1/activity_log/`,
    getEventRules:`${newBaseApi}/api/rules/`
}